import React, { Component, createRef } from "react";

import { FILE_TYPE } from "consts";

export default class extends Component {
  audio = createRef();
  mediaRecorder = null;
  constraints = { video: false, audio: true };
  permissionGranted = false;

  componentDidMount = () => {
    navigator.mediaDevices
      .getUserMedia(this.constraints)
      .then(stream => {
        const audioTracks = stream.getAudioTracks();
        audioTracks.forEach(track => track.stop());
      })
      .catch(this.props.onAccessDenied);
  };

  start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia(this.constraints);
    const audioTracks = stream.getAudioTracks();
    if (this.audio.current) this.audio.current.srcObject = stream;

    const audioChunks = [];
    this.mediaRecorder = new window.MediaRecorder(stream);
    this.mediaRecorder.ondataavailable = e => audioChunks.push(e.data);
    this.mediaRecorder.start();
    this.mediaRecorder.onstop = () => {
      const blob = new window.Blob(audioChunks, { type: "audio/aac" });
      const recordedAudio = window.URL.createObjectURL(blob);
      audioTracks.forEach(track => track.stop());
      this.props.onCapture(recordedAudio, FILE_TYPE.AUDIO);
    };
  };

  stop = () => this.mediaRecorder?.stop();

  render = () => <audio ref={this.audio} />;
}
